var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"standard-flex-box",style:(`
    ${_vm.max_height?`max-height: ${_vm.max_height};`:''}
    ${_vm.height?`height: ${_vm.height};`:''}
    ${_vm.line_height?`line-height: ${_vm.line_height};`:''}
    ${_vm.width?`width: ${_vm.width};`:''}
    ${_vm.direction?`flex-direction: ${_vm.direction};`:''}
    ${_vm.justify_content?`justify-content: ${_vm.justify_content};`:''}
    ${_vm.gap?`gap: ${_vm.gap};`:''}
    ${_vm.align_items?`align-items: ${_vm.align_items};`:''}
    flex-wrap: ${_vm.no_wrap?'nowrap':'wrap'};
    align-content: ${_vm.align_content?_vm.align_content:'flex-start'};
  `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }